module.exports = __webpack_public_path__ + "static/media/tumblr-square.0b1e7819.svg";